import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App, { settings, generalSettings, featureFlagsSettings, stripeSettings, oidcSettings } from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'react-oidc-context';
import { oidcConfig, initOidcConfig } from './auth/authConfig';
import { SettingsClient } from './swagger-clients/s365-dashboard-v2-web-clients.service';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

async function bootstrap() {
  try {
    const baseUrl = window.location.origin === 'https://localhost:44485' 
      ? 'https://localhost:9401' 
      : window.location.origin;
    const client = new SettingsClient(baseUrl);
    const settingsResp = await client.getSettings();

    // Populate global settings
    Object.assign(App, {
      settings: settingsResp?.urlSettings,
      generalSettings: settingsResp?.generalSettings,
      featureFlagsSettings: settingsResp?.featureFlagsSettings,
      stripeSettings: settingsResp?.stripeSettings,
      oidcSettings: settingsResp?.oidcSettings
    });

    if (settingsResp?.oidcSettings && settingsResp?.urlSettings?.dashboardServiceUrl) {
      initOidcConfig(settingsResp.oidcSettings, settingsResp.urlSettings.dashboardServiceUrl);
    }
  } catch (e) {
    console.error("Failed to load settings before bootstrap:", e);
  }

  root.render(
    <AuthProvider {...oidcConfig}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  );
}

bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

